module.exports = __webpack_public_path__ + "img/icon-sample-orange.422a0f5e.svg";